import type { EmitEventType } from '@unifyapps/defs/hooks/useBlockEvents';
import { useRouter } from './useRouter';
import { InterfaceRouterProvider } from '@unifyapps/carbon/no-code/hooks/useRouter';
import DeltaMatrixInterfaceContainer from './DeltaMatrixInterfaceContainer';
import { QueryMeta } from '@unifyapps/network/utils/fetch/types';
import Router from './Router';
import { supportedRouters } from './constants';

type Props = {
  interfaceId: string;
  onClose?: () => void;
  eventEmitterRef?: React.RefObject<{ emitEvent: EmitEventType } | null>;
  queryMeta: QueryMeta;
  routerType?: keyof typeof supportedRouters;
  basePath?: string;
  pageId: string;
  pageInputs?: Record<string, unknown>;
  onPageEvent?: EmitEventType;
};

function App({
  interfaceId,
  onClose,
  eventEmitterRef,
  queryMeta,
  onPageEvent,
}: Pick<Props, 'interfaceId' | 'onClose' | 'eventEmitterRef' | 'queryMeta' | 'onPageEvent'>) {
  const router = useRouter();

  return (
    <InterfaceRouterProvider router={router}>
      <DeltaMatrixInterfaceContainer
        interfaceId={interfaceId}
        queryMeta={queryMeta}
        onClose={onClose}
        eventEmitterRef={eventEmitterRef}
        onPageEvent={onPageEvent}
      />
    </InterfaceRouterProvider>
  );
}

function AppContainer({ routerType = 'memory', pageId, pageInputs, basePath, ...props }: Props) {
  return (
    <Router routerType={routerType} pageId={pageId} pageInputs={pageInputs} basePath={basePath}>
      <App {...props} />
    </Router>
  );
}

export { AppContainer as App };
